import { fetchErrors, months, weekdays } from '../strings.en';

const status = {
  DONE: 'Done',
  DONE_WITH_DEVIATION: 'Done with deviation',
  IN_PROGRESS: 'In progress',
  UNKNOWN: 'Planned',
};

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  disclaimer: {
    text: 'Please observe that this is not a construction document.',
    proceedButton: 'OK',
  },
  geolocation: {
    text: 'Lacking access to your location. Please, manually update your device settings to display current location.',
    proceedButton: 'OK',
  },
  home: 'Home',
  location: 'Your location',
  info: 'Info',
  menu: 'Menu',
  orders: 'Orders',
  reportsMenu: 'Reports',
  reportsPanel: {
    empty: 'No reports available.',
    filterPlaceholder: 'Filter report type',
    searchPlaceholder: 'Search reports',
    hideCompleted: 'Hide completed reports',
    types: {
      span: 'Span',
      cabinet: 'Cabinet',
      manhole: 'Manhole',
      kp: 'Duct point',
      hc: 'HC',
      site: 'Site',
      hub: 'Hub',
    },
  },
  constructionVersion: 'Construction document version',
  constructionExplanation:
    'Latest version & publication date for the construction document in Duktig',
  popup: {
    spanStatus: 'Span status',
    accommodationMethod: 'Accommodation Method',
    permissionType: 'Permission Type',
    length: 'Length',
    expandContent: 'Expand for more information',
    hideExpandedContent: 'Show less information',
    createReport: {
      span: 'Create new report for span',
      well: 'Create new report for well',
      cabinet: 'Create new report for cabinet',
    },
    updateReport: 'Edit report',
    existingSpan: 'Done (span already exists)',
    address: 'Address',
    name: 'Name',
    editSpans: 'Edit spans in report',
  },
  pointInfo: {
    multiDuct: 'Multiduct:',
    color: 'Color:',
    label: 'Label:',
    from: 'From:',
    duct: 'Duct:',
    connectedTo: 'Connected to:',
    showMore: 'Show more information',
    showLess: 'Show less information',
    informationLoading: 'Loading information',
    informationMissing: 'No duct information',
    ductRow: {
      from: 'From',
      to: 'To',
      name: 'Name',
      incoming: 'Incoming',
      outgoing: 'Outgoing',
    },
  },
  infoPopup: {
    name: 'Name',
    description: 'Description',
    freeText: 'Other information',
  },
  sitePopup: {
    name: 'Name',
  },
  hubPopup: {
    name: 'Name',
  },
  permitAreaPopup: {
    CREATED: 'Created',
    IN_PROGRESS: 'In progress',
    COMPLETED: 'Completed',
    APPROVED: 'Approved',
    ADD: 'Add',
    REVISED: 'Revised',
    WORK_DONE: 'Work done',
    INSPECTION_COMPLETED: 'Inspection completed',
    NOT_UTILIZED: 'Not utilized',
    REVOKED: 'Revoked',
    CLOSED_BY_TRV: 'Closed by trv',
    MISPLACEMENT: 'Misplacement',
    EXPIRED: 'Expired',
    SITING_NOT_FILED: 'Siting not filed',
    SITING_PERMIT_FILED: 'Siting permit filed',
    SITING_PERMIT_APPROVED: 'Siting permit approved',
    EXCAVATION_PERMIT_FILED: 'Excavation permit filed',
    EXCAVATION_PERMIT_APPROVED: 'Excavation permit approved',
    type: 'Type',
    name: 'Name',
    description: 'Description',
    status: 'Status',
  },
  duct: {
    loading: 'Loading duct data',
    header: 'Ducts',
    missing: 'Duct data missing',
    from: 'from',
    showSubducts: 'Show inner ducts',
    hideSubducts: 'Hide inner ducts',
  },
  noResourceSelected:
    'Active project missing. Please select a project above or contact your administrator for further access.',
  mapDataError: 'Could not fetch the map data.',
  report: {
    tab1: 'Step 1',
    tab2: 'Step 2',
    addReport: 'Add field report',
    report: 'Field report',
    reports: 'Field reports',
    upload: 'Upload images',
    download: 'Download',
    deviationLength: 'The reported deviation is ',
    reportedLength: 'The reported length is ',
    reportHeaders: {
      span: 'Span',
      length: 'Planned span length',
      accommodationMethod: 'Accommodation method',
      status: 'Status',
      deviationType: 'Define deviation',
      comment: 'Comment',
      commentField: 'Add comment',
      commentPlaceholder: 'Add your comment on the progress here',
      deviationTypes: 'Deviation',
      reportedLength: 'Deviation length (m)',
      deviationMethods: 'Accomodation Methods',
      name: 'Name',
      requirement: 'Requirement',
      objectType: 'Object type',

      type: 'Type',
      well: 'Well',
      slingwell: 'Well',
      cablewell: 'Well',
      cabinet: 'Cable distribution cabinet',
      jointpoint: 'Joint Point',
      info: 'Information Point',
      id: 'Id',
      date: 'Reporting date',
      createdBy: 'Created by',
      contractorComment: 'Contractor comment',
      criteriaReport: 'Criteria Report',
      criteriaInfo:
        'Please read the checklist below and mark the points that have been completed. Note that some items may require an image or video.',
      validationError: 'Please fill in all the required fields',
      clear: 'Clear',
      calculatedPlannedDeviation: 'Planned length is ',
      plannedDeviationText: 'Enter the length of the deviation distance.',
      calculatedDeviation1: 'The length of the deviation span is ',
      calculatedDeviation2: 'This leaves ',
      calculatedDeviation3:
        ' that needs to be reported by choosing deviation methods.',
      commentDeviationPlaceholder:
        'Please, add additional information about the deviation.',
    },
    search: 'Search',
    searchPlaceholder: 'Enter id',
    filterStatus: 'Filter by status',
    chooseStatus: 'Choose status',
    statusDropdownOption: {
      inProgress: 'In progress',
      done: 'Done',
      doneWithDeviation: 'Done with deviation',
      unknown: 'Unknown',
      all: 'All',
    },
    filterType: 'Filter by type',
    status: {
      inProgress: 'In progress',
      done: 'Done',
      deviation: 'Done with deviation',
    },
    invalidField: {
      deviationType: 'Please choose at least one deviation type',
      comment: 'Please write a comment regarding the deviation',
      reportedLength: 'Please write the deviated span length (in meters)',
      workPerformed: 'Please add at least one method',
      totalLengthError:
        'Please make sure that the total length equals the span length',
    },
    suppliedMaterial: 'Part of span length that is case B',
    noSuppliedMaterial: 'No info',
    notSynced: 'Not synchronized',
    chooseDeviation: 'Choose deviation type',
    verificationRequired:
      'The reported length is more than 50% longer than the planned length. Is this correct?',
    methodDeviation: {
      addMethod: 'Add method',
      dropdownPlaceholder: 'Choose method',
      totalLength: 'Total length',
      deviationHeader: 'Deviation length (m)',
      accomoodationMethod: 'Accommodation Method',
    },
    saveReport: 'Save report',
    next: 'Next step',
    dismiss: 'Close',
    success: 'The report was successfully saved!',
    offline:
      'The report has been saved offline and will be uploaded the next time the app is online.',
    error: 'Could not save the report. Please try again.',
    backToReports: 'Back to report list',
    open: 'Open report',
    create: 'Create report',
  },
  projectLevelReport: {
    header: 'Project report',
  },
  installationReport: {
    popUpBtnText: 'Progress planning',
    header: 'Progress planning',
    saveBtn: 'Save report',
    addressLabel: 'Address',
    toOrdersModal: 'To orders overview',
    confirmModal: {
      header: 'Are you sure you want to close the form?',
      text: 'There are unsaved changes. Make sure to save them before closing modal.',
      cancelBtn: 'Take me back to the report',
      closeBtn: 'Yes, close!',
    },
    missingIdMessage: 'Progress planning report id is missing (sourceKey)',
    saveSuccessMessage: 'Progress planning report saved successfully',
    saveErrorMessage:
      'Could not save the progress planning report. Please try again.',
    failToLoadMessage: {
      403: 'Access denied, please log in to view progress planning report.',
      404: 'No progress planning report available for selected residence.',
      408: 'Request Timeout. Please reload the application.',
      500: 'Server problems, please try again later.',
      general: 'Could not load the progress planning report.',
    },
    errorText: 'Could not load report. Please refresh or try again later.',
    form: {
      planedInstallationDate: 'Planned Installation Date',
      bookedCustomerInstallationDate: 'Booked Customer Installation Date',
      siteProjectPlanningExecutedDate: 'Site Project Planning Executed Date',
      siteShaftBooked: 'Site Shaft Booked',
      siteShaftInstallationDate: 'Site Shaft Installation Date',
      fiberCableInstalledForCustomer: 'Fiber Cable Installed For Customer',
      fiberReceiverInstallationDate: 'Fiber Receiver Installation Date',
      macAddress: 'MAC-address CPE',
      email: 'Email',
      name: 'Name',
      phoneNumber: 'Phone number',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Order Overview',
      PLOT_DESIGN: 'Plot Design',
      PLOT_EXCAVATION: 'Plot Excavation',
      DUCT_CONNECTION: 'Duct Connection',
      PRE_INSTALLATION: 'Preinstallation',
      CABLE_BLOWING: 'Cable Blowing',
      SPLICING_MEASURING: 'Splicing & Measuring',
      SPLICING: 'Splicing',
      COMMISSIONING: 'Commissioning',
      MEASURING: 'Measuring',
    },
    modal: {
      header: 'Installation Reporting',
      completedBy: 'Completed by #{user} #{date}',
      closeBtn: 'Close',
      saveBtn: 'Save',
      completeBtn: 'Complete report',
      unlockReportBtn: 'Unlock report',
      reportCompletedBtn: 'Report completed',
      reportCompletedDisabledTooltip:
        'Contact your construction responsible to have the report unlocked.',
      completeBtnDisabledTooltip:
        'The report can be completed once all phases are fully finished.',
      onProceedError: 'Form is not valid',
      cannotSaveNetAdmin: 'Cannot save NetAdmin value.',
    },
    completeConfirmation: {
      title: 'Complete report?',
      whatHappens: 'What happens if you confirm?',
      bulletInvoice:
        'The customer will be invoiced directly after confirmation.',
      bulletLocked: 'The entire report will be locked and cannot be changed.',
      checkboxLabel: 'I have read and understood the above text.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      completedTitle: 'Report completed!',
      completedBody:
        'Customer has been commissioned and invoice has been sent! This report is no longer editable.',
      closeWindow: 'Close this window',
    },
    plotDesignTab: {
      instructions: 'Fill in the information to complete.',
      completed: 'Plot Design - Completed!',
      plannedPlotDesign: 'Planned Plot Design',
      executedPlotDesign: 'Executed Plot Design',
      comment: 'Comment',
      awaitingSign: 'Awaiting sign',
      completedSign: 'Sign completed',
      initiateSign: 'Initiate sign',
    },
    plotExcavationTab: {
      instructions: 'Fill in the information to complete.',
      completed: 'Plot Excavation - Completed!',
      plannedPlotExcavation: 'Planned Plot Excavation',
      executedPlotExcavation: 'Executed Plot Excavation',
      comment: 'Comment',
    },
    ductConnectionTab: {
      instructions: 'Preform self-inspection to complete Duct Connetion!',
      completed: 'Duct Connected',
      executedDate: 'Executed date',
      notConnected: 'Not connected',
      comment: 'Comment',
    },
    orderOverviewTab: {
      infoText:
        'Information about the selected order is shown below. Fill in the reports in the tabs above.',
      subHeader: 'Order Information',
      address: 'Address',
      customerName: 'Customer Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      connectionType: 'Connection Type',
      contactedDate: 'Contacted Customer',
      statusReport: 'Status of Report',
      greenfieldIfs: 'Greenfield IFS',
    },
    preinstallationTab: {
      instructions: 'Fill in the information and preform the control.',
      completed: 'Preinstallation - Completed!',
      plannedPreinstallation: 'Planned Preinstallation',
      executedPreinstallation: 'Executed Preinstallation',
      macAddress: 'MAC-address CPE / Serial number',
      macAddressInputLabel:
        'MAC-address CPE (P2P) or Serial number ONT (XGS-PON)',
      help: 'Help',
      comment: 'Comment',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE Registration',
      netAdminSubHeader:
        'Select Device and fill in value below. Save to register!',
      deviceCategory: 'Device type',
      deviceValue: 'Device value',
      macSerialPlaceholder: 'MAC / Serial number',
      mustMatchFormat: 'Must match format:',
      netAdminStatus: {
        saveToUpload:
          'Fill in MAC-address CPE / Serial number and Save to upload!',
        notSaved: 'Not saved',
        cannotUpload:
          'Saved - but cannot upload without executed date and completed self-inspections.',
        clickSave: 'Click Save to upload to NetAdmin!',
        uploading: 'MAC-address CPE / Serial number has been sent to NetAdmin!',
        uploaded: 'Uploaded & Saved',
      },
      inputPlaceHolder: 'MAC-address CPE or Serial number',
      maxInput: 'Maximum 17 characters allowed.',
      incorrectFormat: 'Incorrect format, see Help for instructions.',
      model: 'Model',
      selection: 'Selection',
    },
    cableBlowingTab: {
      instructions: 'Fill in information to complete this moment.',
      completed: 'Cable Blowing - Completed!',
      plannedCableBlowing: 'Planned Cable Blowing',
      executedCableBlowing: 'Executed Cable Blowing',
      comment: 'Comment',
    },
    splicingAndMeasuringTab: {
      instructions: 'Fill out the information and upload files!',
      completed: 'Splicing & Measuring - Completed!',
      plannedMeasuring: 'Planned Measuring',
      executedMeasuring: 'Executed Measuring',
      plannedSplicing: 'Planned Splicing',
      executedSplicing: 'Executed Splicing',
      fileAndImageUpload: 'File and image upload',
      upload: 'Upload',
      showImages: 'Show images',
      comment: 'Comment',
      commentDescriptionExplanation:
        'Please specify reason for not following panelcard.',
      fiberData: {
        title: 'Fiber Data',
        panelcard: {
          question: 'Has Panelcard been followed?',
          yes: 'Yes',
          no: 'No',
        },
        switchName: 'Switch name',
        switchPort: 'Switch port',
        switchCard: 'Switch card',
        odfInSite: 'ODF in Site',
        odfContact: 'ODF Contact',
        cabinet: 'FOC (Fiber Optic Cabinet)',
        cableIdCabinet: 'CableID in FOC',
        fiberInCabinet: 'Fiber in FOC',
        ductColorInCabinet: 'Ductcolor in FOC',
        splitterPort: 'Splitter Port',
        splitterName: 'Splitter Name',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Number',
          focType: 'Type FOC',
          focCableId: 'Type Cable ID',
          color: 'Type duct color',
          name: 'Type name',
          select: 'Select',
        },
        descriptions: {
          switchNameSyntax: 'Suggested format NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Specify reason for not following panelcard in comment.',
      },
    },
    commissioningTab: {
      instructions: 'Fill in the information and perform control.',
      completed: 'Commissioning - Completed!',
      plannedCommissioning: 'Planned Commissioning',
      executedCommissioning: 'Executed Commissioning',
      plannedMeasuring: 'Planned Measuring',
      executedMeasuring: 'Executed Measuring',
      comment: 'Comment',
    },
    selfInspection: {
      markAsComplete: 'Mark as done',
      uploadImage: 'Upload image',
      showControlled: 'Show controlled',
      undoSelfInspection: 'Undo self inspection',
      handleImage: 'Handle images',
      showAttachments: 'Show attachments',
      updateSelfInspectionErrorMessage: 'Could not save self inspection',
      notApplicableText: 'Describe reason for not applicable',
      cancel: 'Cancel',
      markAsNonApplicable: 'Mark as non-applicable',
      notApplicable: 'Not-applicable',
      editNotApplicableComment: 'Edit description',
      saveChanges: 'Save changes',
      updateSelfInspectionSuccessMessage: 'Description is saved and updated',
      selfInspectionSavedSuccessMessage:
        'The self inspection was successfully saved',
      revertSelfInspectionMessage: 'Self inspection successfully reverted',
      updateSelfInspectionFilesMessage:
        'Self inspection files were successfully updated',
      updateSelfInspectionRevertedMessage:
        'Uploading of images were cancelled.',
      uploadSelfInspectionImageSuccess: 'Images uploaded!',
      uploadSelfInspectionImageError: 'Could not upload images. Try again!',
      deleteSelfinspectionImageSuccess: 'Image has been removed.',
      deleteSelfinspectionImageError: 'Could not remove image.',
      loadingImages: 'Loading images...',
      instructionalImage: {
        DepthExampleImage: 'Include ruler in photo - See example',
      },
      done: 'Done: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Your changes have been saved',
    updateInstallationReportError: 'Your changes could not be saved',
    clearDate: 'Clear date',
    alerts: {
      executedDateAlert: 'Make sure all self-inspections are completed',
      signReady: 'Ready for sign-off',
    },
    imageChecklist: {
      title: 'Image checklist',
      listItems: {
        splicingOutlet: 'Image of splicing in fiber outlet/facade box',
        splicingFOS: 'Image of splicing in FOS',
        sealingDuctFOS: 'Image of sealing duct in FOS',
        hasOdfPortImage: 'Image of ODF port',
        hasSwitchPortImage: 'Image of Switchport',
        hasNodeImage: 'Before and after image in node',
      },
    },
  },
  ...status,
  legend: {
    legendLabel: 'Legend',
    filterLabel: 'Filter',
    spanLayer: 'Span',
    distpointLayer: 'Points',
    hc: 'HC - House Connected',
    hp: 'HP - House Passed',
    well: 'Well',
    cabinet: 'Cable distribution cabinet',
    site: 'Site',
    hub: 'Hub',
    jointpoint: 'Joint Point',
    info: 'Information Point',
    trv: 'TRV - Pressing Point',
    sdp: 'SDP - Duct Endpoint',
    kp: 'KP - Duct Point',
    loa: 'Land owner areas',
    loaDone: 'Land agreement done',
    loaRequired: 'Land agreement missing',
    permitArea: 'Permit area',
    multiHp: 'Multi HP',
    multiHc: 'Multi HC',
    multiHousehold: 'Multi HP/HC',
    multiWell: 'Multi Well',
    spanV2: {
      SELECTED: 'Selected  spans in the same report',
      PLANNED: 'Planned',
      IN_PROGRESS: 'In progress',
      DONE: 'Done',
      RESTORED: 'Restored',
      DEVIATED: 'Restored + Deviation',
      EXISTING: 'Existing',
    },
    selectAll: 'Select all',
  },
  definition: {
    unknown: 'Unknown',
    noTranslation: 'Translation unavailable',
  },
  projectOverview: {
    header: 'Project overview',
    compileButton: 'Compile',
    from: 'From',
    to: 'To',
    compiledData: 'Compiled Data',
    reportCount: 'Number of reports',
    totalPlannedDeviation: 'Difference to planned length',
    totalPerformed: 'Performed length',
    tableHeaders: {
      method: 'Method',
      plannedLengthDeviation: 'Deviation from planned length (m)',
      performedLength: 'Performed (m)',
    },
  },
  duktsSidebar: {
    ductId: 'Duct id ',
    type: 'Type',
    color: 'Color',
  },
  datepickerPlaceholder: 'YYYY-MM-DD',
  dateFormatError: 'You have filled in an incorrect date (YYYY-MM-DD).',
  tableConfiguration: {
    title: 'Configure table',
    cancel: 'Cancel',
    apply: 'Apply',
    showAllColumns: 'Show all columns',
  },
  fetchErrors,
  ...weekdays,
  ...months,
  rolloutProgressLabel: 'Rollout Progress',
  ducts: 'Ducts',
  subDucts: 'Sub-ducts',
  searchDucts: 'Name, id or color',
  clear: 'Clear',
  errorFetchingDucts: 'Could not fetch ducts',
  close: 'Close',
  searchDuct: 'Search duct',
  ordersOverview: {
    modalHeader: 'Orders overview',
    formFilterHeader: 'Filter',
    formFilterOrdersHeader: 'Filter orders',
    filterInputPlaceholder: 'address, customer name, city..',
    mapMenuButton: 'Orders overview',
    downloadExcel: 'Download Excel',
    downloadSuccess: 'Excel file downloaded',
    downloadError: 'Excel file could not be downloaded.',
    downloadPdfStarted:
      'Generating PDF for {address}. PDF generation may take a while depending on the report size.',
    downloadPdfSuccess: 'PDF downloaded successfully',
    downloadPdf429Title: 'Please wait',
    downloadPdfError429:
      'PDF generation is busy, please wait a moment and try again.',
    downloadPdfErrorGeneric: 'Failed to generate PDF, please try again.',
    downloadPdfCancelled:
      'PDF download was cancelled because the table was closed.',
    downloadPdfCancelledPopup:
      'PDF download was cancelled because the popup was closed.',
    filterOptions: {
      showAll: 'Show all',
      incomplete: 'Show incomplete',
      complete: 'Show complete',
    },
    tableHeaders: {
      address: 'Address',
      customerName: 'Customer name',
      completedDate: 'Completed date',
      latestStatus: 'Latest status',
      statusDate: 'Status date',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Installation date',
      pdf: 'PDF',
      planedInstallationDate: 'Planned installation',
      bookedCustomerInstallationDate: 'Booked installation',
      siteProjectPlanningExecutedDate: 'Site project planning executed',
      siteShaftBooked: 'Site shaft booked',
      siteShaftInstallationDate: 'Site shaft installation',
      fiberCableInstalledForCustomer: 'Fiber cable installed',
      fiberReceiverInstallationDate: 'Fiber receiver installation',
      plotDesignDate: 'Plot Design',
      preinstallationDate: 'Preinstallation',
      plotExcavationDate: 'Plot Excavation',
      ductConnection: 'Duct Connection',
      cableBlowingDate: 'Cable Blowing',
      splicingAndMeasuringDate: 'Splicing & Measuring',
      splicingAndMeassuringDate: 'Splicing & Measuring',
      splicingDate: 'Splicing',
      measuringDate: 'Measuring',
      commissioningDate: 'Commissioning',
      macAddress: 'MAC-address CPE',
    },

    true: 'Yes',
    false: 'No',
    error: 'Could not load any orders, please try again later.',
    latestStatus: {
      ORDERED: 'Ordered',
      ORDERED_FOR_BUILD: 'Ordered for build',
      CANCELLED: 'Cancelled',
      REVOKED: 'Revoked',
      WITHDRAWN: 'Withdrawn',
      ESCALATED: 'Escalated',
      CONSTRUCTION_DEVIATION: 'Constructural deviation',
      NOT_VALIDATED: 'Not validated',
      WARNING: 'Warning',
      INSTALLED: 'Installed',
      UNKNOWN: 'Unknown',
    },
    status: 'Status',
  },
  selfReportingPoints: {
    modalHeader: 'Field reporting',
    cancelButton: 'Cancel',
    proceedButton: 'Save & quit',
    unsavedChanges: 'Unsaved changes. Save before closing!',
    name: 'Name',
    object: 'Object',
    uploadingFiles: 'Uploading files...',
    status: {
      header: 'Status',
      started: 'Started',
      done: 'Done',
      doneWithDeviation: 'Done with deviation',
      deviationHeader: 'Describe deviation',
      deviationPlaceholder: 'Comment...',
    },
    selfInspection: {
      header: 'Self inspection',
      switchHeader: 'Add description',
      description:
        'Go through each point and make sure the job is done as described. Note that some items require an image while others may only require your approval by checking the box.',
    },
    selfInspectionHeaders: {
      CABINET_ESTABLISHMENT: 'Setting cabinet',
      FIBER_OPTICS: 'Fiber work',
      LABELING: 'Marking',
      MANHOLE_ESTABLISHMENT: 'Setting well',
      JOINT_BOX: 'Joint box',
      RESTORATION: 'Restoration',
    },
    showCompleted: 'Show controlled',
    couldNotBeCompleted: 'Could not be completed',
    uploadFile: 'Attachment',
    markComplete: 'Mark as complete',
    pdfLink: 'Open instruction image in new window',
    addImage: 'Add image',
    undoSelfInspection: 'Undo self inspection',
    addedBy: 'Added by',
    alertCouldNotBeCompleted:
      'Certain self inspections could not be completed. Provide reasoning at the top of the page!',
    toastSaveSuccess: 'Your changes have been saved!',
    errorPreventionSaveModal: {
      title: 'Do you want to save your changes?',
      confirm: 'Yes',
      deny: 'No',
    },
    error: 'Something went wrong, please try again later.',
  },

  imageThumbnail: {
    addedBy: 'Added by: ',
  },
  hpReportModal: {
    modalHeader: 'Progress planning - HP',
    proceedButtonText: {
      create: 'Create',
      update: 'Update',
    },
    error: {
      noProps: 'Marker has no data!',
    },
    pill: {
      done: 'Done',
      doneWithoutImages: 'Done without images',
      notDone: 'Not Done',
      status: 'Status',
      address: 'Address',
    },
    checkBox: 'Mark as done',
    images: {
      uploadedFiles: 'Uploaded images',
      noUploadedFiles: 'No uploaded iamges',
      removeFilesButton: 'Remove all',
      addFilesButton: {
        choose: 'Choose files',
        more: 'Add more +',
      },
    },
    toolTip: {
      removeFile: 'Remove an image from the report',
      keys: {
        fileName: 'Filename',
        size: 'Size',
        uploaded: 'Uploaded',
        createdBy: 'Uploaded by',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
    },
    toast: {
      create: 'Progress report created for HP',
      update: 'Progress report update for HP',
      duplicateFileName: 'duplicated filename! For file ',
      delete: 'Progress report deleted',
    },
  },
  placmentImageLink: {
    title: 'Open instruction image in new tab',
  },
  imagePreview: {
    header: 'Image preview',
    upload: 'Upload',
    cancel: 'Cancel',
    noImages: 'Click to attach files',
    loadingImages: 'Loading...',
  },
  imagePreviewV2: {
    preview: 'Preview',
    addImages: 'Add images',
    close: 'Close',
    downloadAll: 'Download all',
    editImages: 'Edit images',
    manageImages: 'Manage images',
    done: 'Done',
    deleteImageQuestion: 'Delete image?',
    confirmDelete: 'Yes, delete',
    cancel: 'Cancel',
    confirmDeleteText: 'Are you sure you want to delete this image?',
    pleaseWait: 'Please wait...',
    download: 'Download',
    images: 'Images',
    imageDeleted: 'Image deleted',
    saved: 'Saved!',
    uploaded: 'Uploaded',
    noImagesAvailable: 'No images available',
    addImagesBelow: 'You can add images below!',
  },
  macAddressInvalid: 'Invalid MAC-address',
  Huvudbyggnad: 'Main building',
  Extraanslutning_seperat_byggnad: 'Extra connection separate building',
  Extraanslutning_inom_huvudbyggnad:
    'Extra connection within the main building',

  searchComponent: {
    placeholder: 'Search for address or object name',
  },
  workSectionStatus: {
    EXECUTED: 'Executed',
    PLANNED: 'Planned',
    AWAITING_PLANNING: 'Awaiting planning',
    INCOMPLETE: 'Incomplete',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'The work has been completed',
    PLANNED: 'The work has been scheduled but not yet completed',
    AWAITING_PLANNING: 'The work has not been planned yet',
    INCOMPLETE: 'Incomplete self-inspections while set as executed',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Not Connected',
  },
  fileUpload: {
    error: 'Files could not be uploaded',
    loadingImages: 'Loading images...',
  },
  select: 'Select ',
  tableFilter: {
    orderFilterssSectionHeader: ' selected filters',
    addFilterButton: 'Add filter',
    applyFilterButton: 'Apply filters',
    clearAllFiltersButton: 'Clear all filters',
    noFilteredOrders: 'No orders were found.',
    accessId: {
      existing: 'NetAdmin ID - Existing',
      notExisting: 'NetAdmin ID - Not existing',
    },
    plotDesign: {
      planned: 'Plot Design - Planned',
      awaitingPlanning: 'Plot Design - Awaiting planning',
      executed: 'Plot Design - Executed',
    },
    preinstallation: {
      planned: 'Preinstallation - Planned',
      awaitingPlanning: 'Preinstallation - Awaiting planning',
      executed: 'Preinstallation - Executed',
    },
    plotExcavation: {
      planned: 'Plot Excavation - Planned',
      awaitingPlanning: 'Plot Excavation - Awaiting planning',
      executed: 'Plot Excavation - Executed',
    },
    ductConnection: {
      connected: 'Duct Connected - Connected',
      notConnected: 'Duct Connected - Not Connected',
    },
    cableBlowing: {
      planned: 'Cable Blowing - Planned',
      awaitingPlanning: 'Cable Blowing - Awaiting planning',
      executed: 'Cable Blowing - Executed',
    },
    measuring: {
      planned: 'Splicing & Measuring - Planned',
      awaitingPlanning: 'Splicing & Measuring - Awaiting planning',
      executed: 'Splicing & Measuring - Executed',
    },
    commission: {
      planned: 'Commissioning - Planned',
      awaitingPlanning: 'Commissioning - Awaiting planning',
      executed: 'Commissioning - Executed',
    },
    perPage: 'Show per page: ',
  },
  multiPointModal: {
    header: {
      hp: 'Multi HP',
      hc: 'Multi HC',
      well: 'Multi Well',
      household: 'Multi HC/HP',
    },
    tabs: {
      hp: 'HP',
      hc: 'HC',
      well: 'Well',
    },
    closeBtn: 'Close',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Uploaded',
      success: 'Uploaded',
      error: 'Upload failed. Try again',
      tooLarge: 'File is too large (max 15MB).',
    },
    undoSelfInspection: {
      success: 'Undone',
      error: 'Failed to undo. Try again',
    },
    markAsNA: {
      success: 'Marked as N/A',
      error: 'Failed to mark as N/A. Try again',
    },
    save: {
      success: 'Saved',
      error: 'Failed to save. Try again',
      spanAlreadyPartOfReport: 'Span already exists in another report',
    },
    remove: {
      success: 'Removed',
      error: 'Failed to remove. Try again',
    },
  },
  reportStatus: {
    DONE_WITH_DEVIATION: 'Done with deviation',
    UNKNOWN: 'Unknown',
    DONE_WITHOUT_IMAGES: 'Done without images',
    NOT_STARTED: 'Not started',
    PERMIT_DONE: 'Permit - Approved',
    PLACEMENT_OF_SITE_DONE: 'Placement of Site - Completed',
    SITE_INSPECTION_DONE: 'Site Inspection - In service',
    PLACEMENT_OF_HUB_DONE: 'Placement of Hub - Completed',
    HUB_INSPECTION_DONE: 'HUB inspection - In service',
    DONE: 'Done',
    PLANNED: 'Planned',
    IN_PROGRESS: 'In progress',
    RESTORED: 'Restored',
    SETTING_CABINET_DONE: 'Setting cabinet - Completed',
    FIBER_WORK_DONE: 'Fiber work - Completed',
    MARKING_DONE: 'Marking - Completed',
    SETTING_WELL_DONE: 'Setting well - Completed',
    JOINT_BOX_DONE: 'Joint box - Completed',
    WELL_RESTORATION_DONE: 'Restoration - Completed',
  },
  reportInfo: {
    lastUpdatedBy: 'Last updated by',
    address: 'Address',
    objectName: 'Object name',
    status: 'Status',
    deviation: 'Deviation',
    reportStatusIcon: 'Report status icon',
    referenceLabel: {
      SITE: 'Object name',
      HUB: 'Object name',
      HP: 'Address',
      SPAN: 'Span ID',
      CABINET: 'Object name',
      MANHOLE: 'Object name',
    },
    method: 'Method',
    spanType: 'Type',
    length: 'Length',
    meters: 'meters',
    comment: {
      label: 'Comment',
      placeholder: 'Type something...',
    },
  },
  reportInput: {
    save: 'Save',
    cancel: 'Cancel',
    done: 'Done: ',
    na: 'N/A: ',
    addMore: 'Add more',
    upload: {
      files: 'Upload files',
      images: 'Upload images',
    },
    viewImages: 'View images',
    remove: 'Remove',
    download: 'Download',
    markAsDone: 'Mark as done',
    description: 'Description',
    instructionImage: 'Open instruction',
    optionsButton: {
      markAsNA: 'Mark as not-applicable',
      editDescription: 'Edit description',
      uploadImages: 'Upload images',
      undo: 'Undo self-inspection',
    },
    errorPreventionModal: {
      undoSelfInspectionQuestion: 'Undo self-inspection?',
      undoSelfInspection: 'Undo self-inspection',
      cancel: 'Cancel',
      text: 'All information and images will be removed if you undo self-inspection.',
    },
    noPointReport: 'Marker does not exist in selected IFS',
    noSpanReport: 'Span does not exist in selected IFS',
    errorReport: 'Could not fetch report. Refresh or try again later.',
    text: {
      label: 'Describe reason',
      placeholder: 'Type reason...',
    },
  },
  signingCard: {
    title: 'Signing of Plot Design',
    information:
      'Perform all required self-inspections and enter executed date to enable signing.',
    startSigning: 'Start signing',
    newSigning: 'New signing',
  },
  spanAccomodationMethod: {
    unknown: 'Unknown',
    direct: 'Direct',
    softDigging: 'Soft digging',
    hammarDrilling: 'Hammer drilling',
    groundRocket: 'Ground rocket',
    chainDigging: 'Chain digging',
    microTrenching: 'Micro trenching',
    plowing: 'Plowing',
    slotting: 'Slotting',
    guidedDrilling: 'Guided drilling',
    pressing: 'Pressing',
    moving: 'Excavation',
    manualMoving: 'Manual excavation',
    clamping: 'Clamping',
    clampingOnRock: 'Clamping on rock',
    clampingOnLadder: 'Clamping on ladder',
    existing: 'Existing',
  },
  spanAccomodationType: {
    unknown: 'Unknown',
    ground: 'Ground',
    asphalt: 'Asphalt',
    tunnel: 'Tunnel',
    bridge: 'Bridge',
    radioLink: 'Radio link',
    air: 'Air',
    lake: 'Lake',
    field: 'Field',
    gravel: 'Gravel',
  },
  selectSpanMode: {
    title: 'Select spans for report',
    editTitle: 'Edit spans in report',
    subtitle: 'Click on the spans you want to include in the report.',
    editSubtitle: 'Click on spans to add or remove them from the report.',
    meters: 'm',
    selectedDistance: 'Selected distance',
    cancel: 'Cancel',
    createReport: 'Create report',
    updateReport: 'Save changes',
    warningMaxSpanLength: 'Max 200 m allowed for multiple spans.',
    help: 'Help',
    spanExistsInOtherReport: 'Span is part of another report',
    propertySpanCannotBeReported: 'Property span cannot be reported.',
    existingSpanCannotBeReported: 'Span completed in another project.',
    helpModal: {
      title: 'Selecting spans',
      spanColorGuide: {
        title: 'Span color guide',
        colorNames: {
          cyan: 'Cyan',
          black: 'Black',
          purple: 'Purple',
          green: 'Green',
          darkGreen: 'Dark Green',
          red: 'Red',
        },
        description: {
          SELECTED: 'Selected & spans in same report',
          PLANNED: 'Planned',
          IN_PROGRESS: 'In progress',
          DONE: 'Done',
          RESTORED: 'Restored',
          DEVIATED: 'Restored with deviation',
        },
      },
      addingSpans: {
        title: 'Adding spans',
        body: 'Click on the spans to select them. Selected and included spans are highlighted in cyan and made thicker.',
      },
      removingSpans: {
        title: 'Removing spans',
        body: 'Click on a selected (cyan) span to deselect it. The highlight will disappear, and it will be excluded from the report.',
      },
      spansNotAllowedForSelection: {
        title: 'Spans not allowed for selection',
        body: "Spans in other reports can't be selected. Remove them from their current report first. They may be another color or black if they belong to a planned report.",
      },
    },
  },
  copied: 'Copied',
  portConnectionStatus: {
    portConnection: 'Port connection',
    noMac: 'No valid MAC address or Serial number in Preinstallation',
    toPreinstallation: 'Go to Preinstallation',
    checkStatus: 'Check the port connection status.',
    checkConnection: 'Check connection',
    loadingState: 'Checking status. Please wait...',
    linking: 'Linking',
    notLinking: 'Not linking',
    installationDate: 'Installation date: ',
    checkAgain: 'Check again',
    debugMessage: 'Please troubleshoot and try again.',
  },
};
